module.exports = __webpack_public_path__ + "static/media/pieta.b5b2ee84.png";